<ng-container *ngIf="chart">
  <h2>{{ chart.title }}</h2>
  <div fxLayout="row" *ngIf="chart.chartBuilder">
    <pr-chart fxFlex [chartBuilder]="chart.chartBuilder" />
  </div>
</ng-container>
